const customerAdministrators = [
  'aschehougad_tora.hommedal.blikas@aschehoug.no',
  'aschehougad_katrine.ajer@aschehoug.no',
  'aschehougad_hilde.erika.lund@aschehoug.no',
  'aschehougad_anemarte.bergan@aschehoug.no',
  'aschehougad_anne.smedstad@aschehoug.no',
  'aschehougad_oystein.haugsbo@aschehoug.no',
  'aschehougad_inger.sofie.solli@aschehoug.no',
  'aschehougad_georg.kjoll@universitetsforlaget.no',
  'aschehougad_mathilde.linnestad@aschehoug.no',
  'aschehougad_mona.solnes@aschehoug.no',
  'aschehougad_sofi.sahlin@aschehoug.no',
  'aschehougad_annsofi.klevfoss@aschehoug.no',
  'aschehougad_irene.lohre@aschehoug.no',
  'aschehougad_mathias.nystuen.lie@aschehoug.no',
  'aschehougad_jan.fongen@aschehoug.no',
  'aschehougad_sverre.blixrud@aschehoug.no',
  'aschehougad_kai.lutzenkirchen@aschehoug.no',
  'aschehougad_sondre.midtboen@aschehoug.no',
  'aschehougad_amanda.scheie@universitetsforlaget.no',
  'aschehougad_william.blomberg@aschehoug.no',
  'aschehougad_andreas.hovstad@universitetsforlaget.no',
  'aschehougad_daniel.restad@aschehoug.no',
  'aschehougad_trine.alnes@universitetsforlaget.no',
  'aschehougad_kristian.vorkinn@universitetsforlaget.no',
  'aschehougad_atussa.hosseini@universitetsforlaget.no',
  'aschehougad_lars.nersveen@aschehoug.no',
  'aschehougad_harald.kittang@aschehoug.no',
  'aschehougad_dag-erik.moller@aschehoug.no',
  'aschehougad_kristian.stromsnes@aschehoug.no',
  'aschehougad_ingun.holoyen@aschehoug.no',
  'aschehougad_havard.bjerkeng@universitetsforlaget.no',
  'aschehougad_daniel.tilrem@universitetsforlaget.no',
  'aschehougad_dag.karlsson@universitetsforlaget.no',
  'aschehougad_ingeborg.marken@universitetsforlaget.no',
];

const contentAdministrators = [
  'aschehougad_irene.lohre@aschehoug.no',
  'aschehougad_turi.lundeby@aschehoug.no',
  'aschehougad_ingvild.aabye@aschehoug.no',
  'aschehougad_kristian.stromsnes@aschehoug.no',
  'aschehougad_kai.lutzenkirchen@aschehoug.no',
  'aschehougad_swensen@aschehoug.no',
  'aschehougad_kari.ryan@aschehoug.no',
  'aschehougad_ingun.holoyen@aschehoug.no',
];

const admins = [
  'aschehougad_bente.martinsen@aschehoug.no',
  'aschehougad_ludvik.blunck@aschehoug.no',
  'aschehougad_marco.giannetti@aschehoug.no',
  'aschehougad_morten.jacobsen@aschehoug.no',
  'aschehougad_hakon.horvei@aschehoug.no',
  'aschehougad_christian.calmeyer@aschehoug.no',
  'aschehougad_fredrik.tidemann@aschehoug.no',
  'aschehougad_hans.fredrik.maast@aschehoug.no',
  'aschehougad_anastasiia.bogolepova@aschehoug.no',
  'aschehougad_aaron.arrick@aschehoug.no',
  'aschehougad_thomas.parsli@aschehoug.no',
  'aschehougad_lars-kristian.ostby@aschehoug.no',
  'aschehougad_stine.skalleberg@aschehoug.no',
  'aschehougad_geir.marius@aschehoug.no',
  'aschehougad_odd.arild.meling@universitetsforlaget.no',
  'aschehougad_torgeir.krohn@aschehoug.no',
  'aschehougad_anders.martinsen@aschehoug.no',
  'aschehougad_bjorn.kvernstuen@aschehoug.no',
  'aschehougad_kim.harwiss@aschehoug.no',
  'aschehougad_thor.arisland@aschehoug.no',
  'aschehougad_colin.ntenga@universitetsforlaget.no',
  'aschehougad_kristiane.steinset@universitetsforlaget.no',
  'aschehougad_lars.aker@universitetsforlaget.no',
  'aschehougad_stine.messel@aschehoug.no',
  'aschehougad_ellen.halleraker@aschehoug.no',
  'aschehougad_pia.sooriyamoorthy@aschehoug.no',
  'aschehougad_kristiane.steinset@universitetsforlaget.no',
];

export const isAdmin = (username) => admins.includes(username.toLowerCase())
export const isCustomerAdministrator = (username) => isAdmin(username) || customerAdministrators.includes(username.toLowerCase());
export const isContentAdministrator = (username) => isAdmin(username) || contentAdministrators.includes(username.toLowerCase());
